export default __webpack_public_path__ + "static/SRUS 3147 - Product Specifications & Technical Data-34413314ee8e0e2f718fe03164b36a3b.pdf";